// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"_tV7_Q"};